import { css } from "@emotion/react";

export default css`
  .dark-input-label:-webkit-autofill,
  .dark-input-label:-webkit-autofill:hover,
  .dark-input-label:-webkit-autofill:focus,
  .dark-input-label:-webkit-autofill:active {
    transition: background-color 5000s ease-in-out 0s;
  }
  .dark-input-label:-webkit-autofill {
    -webkit-text-fill-color: #fff !important;
  }
  .vi__container {
    width: 100% !important;
    margin-top: 1rem;
    .vi__character--default {
      border: 0;
      border-bottom: 1px solid #696969;
    }
  }
  ul {
    list-style: none;
  }
  .drawer .active {
    position: relative;
    li {
      background: rgba(0, 0, 0, 0.04) !important;
    }
    :after {
      content: "";
      position: absolute;
      top: 50%;
      left: 0;
      transform: translateY(-50%);
      width: 4px;
      height: 100%;
      background: #696969;
    }
  }
  /* Chrome, Safari, Edge, Opera */
  input::-webkit-outer-spin-button,
  input::-webkit-inner-spin-button {
    -webkit-appearance: none;
    margin: 0;
  }

  /* Firefox */
  input[type=number] {
    -moz-appearance: textfield;
  }

  * {
    outline: 0 !important;
  }
`;
